// Function to resize an image from a URL and return a Blob

export {
  multiUpload,
  singleUpload
};

async function multiUpload(formData, newArrays, oldArrays) {
  if (newArrays) {
    // newArrays.forEach((image, index) => {
    //   formData.append(`images[${index}]`, image.file);
    // });

    // Add to body
    newArrays.forEach((image) => {
      if (image.file) {
        formData.append('images', image.file);
        if(image.selected){
          formData.append('filename_selected', image.name);
          if(image.location){
            formData.append('location_detected', image.location);
          }
          if(image.timestamp && image.timestamp > 0){
            formData.append('timestamp_detected', image.timestamp);
          }
        }
      }
    });
  }
  
  removeImages(formData, newArrays, oldArrays);
}

function removeImages(formData, newArrays, oldArrays){
  // Handle the case where oldArrays might be null or an empty array
  // const nonMatchingItems = (!newArrays || newArrays.length === 0) ? [] : oldArrays.filter(itemO =>
  //   !newArrays.some(itemN => itemN.id === itemO.id)
  // );

  // Non matching item ids
  const nonMatchingItems =
    !newArrays || newArrays.length === 0 || !oldArrays || oldArrays.length === 0
      ? []
      : oldArrays
          .filter((itemO) => !newArrays.some((itemN) => itemN.id === itemO.id))
          .map((item) => item.id);

  // Add ids need remove
  if (nonMatchingItems.length > 0) {
    formData.append('remove', nonMatchingItems);
  }
}

function singleUpload(formData, newImage, oldImage) {
  if (newImage) {
    // Add to body
    formData.append('image', newImage);
  }

  // Add id need remove
  if (newImage && oldImage) {
    formData.append('remove', oldImage.id);
  }
}
